
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class BaseCurrencyAmount extends Vue {
  @Prop(String)
  currency!: string;

  @Prop({ type: [String, Number] })
  amount!: string | number;

  get value(): string | undefined {
    const amount =
      typeof this.amount === 'string' ? parseFloat(this.amount) : this.amount;
    const amountLocale = this.$n(amount, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return `${this.currency} ${amountLocale}`;
  }
}
